import blurredBackground from '../assets/landing/blurred-background.png'
import carouselImg1 from '../assets/landing/DPF-carousel-img-1.png'
import carouselImg2 from '../assets/landing/DPF-carousel-img-2.png'
import carouselImg3 from '../assets/landing/DPF-carousel-img-3.png'
import featureImg1 from '../assets/landing/DPF-feature-img-1.png'
import featureImg2 from '../assets/landing/DPF-feature-img-2.png'
import featureImg3PostPurchaseModal from '../assets/landing/DPF-feature-img-3-post-purchase-modal.png'
import featureImg3 from '../assets/landing/DPF-feature-img-3.png'
import memoryImg1 from '../assets/landing/DPF-memory-img-1.png'
import premiumFeatures1 from '../assets/landing/DPF-premium-features-1.png'
import premiumFeatures2 from '../assets/landing/DPF-premium-features-2.png'
import premiumFeatures3 from '../assets/landing/DPF-premium-features-3.png'
import presentImg1 from '../assets/landing/DPF-present-img-1.png'
import priceImg1 from '../assets/landing/DPF-price-img-1.png'
import stepsImg1 from '../assets/landing/DPF-steps-img-1.png'
import stepsImg2 from '../assets/landing/DPF-steps-img-2.png'
import stepsImg3 from '../assets/landing/DPF-steps-img-3.png'
import enBackSoonRegular from '../assets/landing/en_DPF-back-soon-regular.png'
import enCherishMomentsImg1 from '../assets/landing/en_DPF-cherish-moments-img-1.png'
import enFeatureImg1 from '../assets/landing/en_DPF-feature-img-1.png'
import enFeatureImg2 from '../assets/landing/en_DPF-feature-img-2.png'
import enFeatureImg3 from '../assets/landing/en_DPF-feature-img-3.png'
import enPriceImg1 from '../assets/landing/en_DPF-price-img-1.png'
import enStepsImg1 from '../assets/landing/en_DPF-steps-img-1.png'
import enStepsImg2 from '../assets/landing/en_DPF-steps-img-2.png'
import enStepsImg3 from '../assets/landing/en_DPF-steps-img-3.png'
import enHeaderCutoutRegular from '../assets/landing/en_header-cutout-regular.png'
import enHeaderStaticRegular from '../assets/landing/en_header-static-regular.png'
import enHighlight1 from '../assets/landing/en_highlight-1.png'
import enHighlight2 from '../assets/landing/en_highlight-2.png'
import enHighlight3 from '../assets/landing/en_highlight-3.png'
import enVideoThumbnail from '../assets/landing/en_video-thumbnail.png'
import headerCutoutPostPurchaseModal from '../assets/landing/header-cutout-post-purchase-modal.png'
import headerCutoutRegular from '../assets/landing/header-cutout-regular.png'
import headerStaticPostPurchaseModal from '../assets/landing/header-static-post-purchase-modal.png'
import headerStaticRegular from '../assets/landing/header-static-regular.png'
import videoThumbnail from '../assets/landing/video-thumbnail.png'
import voiceAvatar1 from '../assets/landing/voice-avatar-1.png'
import voiceAvatar2 from '../assets/landing/voice-avatar-2.png'
import voiceAvatar3 from '../assets/landing/voice-avatar-3.png'
import voiceAvatar4 from '../assets/landing/voice-avatar-4.png'
import voiceAvatar5 from '../assets/landing/voice-avatar-5.png'
import voiceAvatar6 from '../assets/landing/voice-avatar-6.png'

interface LandingAssets {
  blurredBackground: string
  carouselImages: string[]
  featureImages: {
    default: string[]
    postPurchaseModal: string[]
  }
  highlights: string[]
  memoryImg1: string
  premiumFeatureIcons: string[]
  presentImg1: string
  priceImg1: string
  soldOutNoticeImg?: string
  stepImages: string[]
  headers: {
    regular: {
      cutout: string
      static: string
    }
    postPurchaseModal: {
      cutout: string
      static: string
    }
  }
  videoThumbnail: string
  voiceAvatars: string[]
}

const jaLandingAssets: LandingAssets = {
  blurredBackground,
  carouselImages: [carouselImg1, carouselImg2, carouselImg3],
  featureImages: {
    default: [featureImg1, featureImg2, featureImg3],
    postPurchaseModal: [featureImg1, featureImg2, featureImg3PostPurchaseModal],
  },
  highlights: [],
  memoryImg1,
  premiumFeatureIcons: [premiumFeatures1, premiumFeatures2, premiumFeatures3],
  presentImg1,
  priceImg1,
  stepImages: [stepsImg1, stepsImg2, stepsImg3],
  headers: {
    regular: {
      cutout: headerCutoutRegular,
      static: headerStaticRegular,
    },
    postPurchaseModal: {
      cutout: headerCutoutPostPurchaseModal,
      static: headerStaticPostPurchaseModal,
    },
  },
  videoThumbnail,
  voiceAvatars: [
    voiceAvatar1,
    voiceAvatar2,
    voiceAvatar3,
    voiceAvatar4,
    voiceAvatar5,
    voiceAvatar6,
  ],
}

const enLandingAssets: LandingAssets = {
  ...jaLandingAssets,
  carouselImages: [enCherishMomentsImg1],
  featureImages: {
    default: [enFeatureImg1, enFeatureImg2, enFeatureImg3],
    postPurchaseModal: [enFeatureImg1, enFeatureImg2, enFeatureImg3],
  },
  highlights: [enHighlight1, enHighlight2, enHighlight3],
  memoryImg1: enFeatureImg2,
  premiumFeatureIcons: jaLandingAssets.premiumFeatureIcons,
  presentImg1: enBackSoonRegular,
  priceImg1: enPriceImg1,
  soldOutNoticeImg: enBackSoonRegular,
  stepImages: [enStepsImg1, enStepsImg2, enStepsImg3],
  headers: {
    ...jaLandingAssets.headers,
    regular: {
      cutout: enHeaderCutoutRegular,
      static: enHeaderStaticRegular,
    },
  },
  videoThumbnail: enVideoThumbnail,
}

export const landingAssets = {
  ja: jaLandingAssets,
  en: enLandingAssets,
}

export function landingAssetsForLocale(locale?: string) {
  return locale?.startsWith('en') ? landingAssets.en : landingAssets.ja
}
